export const ALLTAGS = "allTags";
export const SEARCH_PAGE = "searchPage";
export const DOCFLIX_DOC_CONSTANT = "Docflix";
